<template>
    <v-dialog
        v-model="showCreateGroup"
        v-if="showCreateGroup"
        persistent
        max-width="800"
    >
        <validation-observer v-slot="{ handleSubmit }">
            <div class="group-create-wrapper">
                <div class="group-create-header">
                    <span v-if="isCreateGroup" class="">
                        TẠO NHÓM CHỈ SỐ
                    </span>
                    <span v-else class="group-create-name">
                        SỬA NHÓM CHỈ SỐ
                    </span>
                    <v-icon
                        size="24"
                        @click="closeModal"
                    >
                        mdi-close
                    </v-icon>
                </div>
                <div class="group-create-form">
                    <div class="input-form">
                        <div class="group-create-label pt-3">
                            Tên nhóm *
                        </div>
                        <div class="input-wrapper col py-0 px-7">
                            <validation-provider
                                v-slot="{ errors }"
                                rules="required"
                                name="Tên nhóm"
                            >
                                <v-text-field
                                    class="group-create-input"
                                    placeholder="Nhập tên nhóm..."
                                    v-model="group.name"
                                    :error-messages="errors"
                                />
                            </validation-provider>
                        </div>
                    </div>
                </div>
                <div class="col text-center">
                    <button
                        class="cancel-btn"
                        @click="closeModal"
                    >
                        BỎ QUA
                    </button>
                    <button
                        class="accept-btn"
                        @click="handleSubmit(saveGroup)"
                    >
                        LƯU
                    </button>
                </div>
            </div>
        </validation-observer>
    </v-dialog>
</template>

<script>
export default {
    props: {
        showCreateGroup: {
            type: Boolean,
            default: false
        },
        group: {
            type: Object,
            default: () => {}
        },
        isCreateGroup: {
            type: Boolean,
            default: true
        },
        allowAcceptGroup: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        closeModal() {
            Bus.$emit('close-group-create-modal')
        },

        saveGroup() {
            if (this.allowAcceptGroup) {
                Bus.$emit('action-save-group')
                Bus.$emit('save-indicator-group', this.group)
            }
        }
    }
}
</script>

<style scoped>
.group-create-wrapper {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 6px 24px rgba(0, 0, 0, 0.1);
}

.group-create-header {
    padding: 15px 0px;
    margin: 0px 20px 0px 30px;
    border-bottom: 1px solid #E0E0E0;
}

.group-create-header i {
    float: right;
    cursor: pointer;
}

.group-create-name {
    font-size: 20px;
    font-weight: 600;
}

.group-create-label {
    font-size: 16px;
}

.input-form {
    display: flex;
    width: 100%;
    padding: 10px 20px 25px 30px;
}

.input-wrapper {
    height: 48px;
}

.group-create-input {
    width: 100%;
    background-color: #F8F8F8;
    height: 100%;
    padding: 5px 20px;
    font-size: 16px;
    outline: unset;
    border-radius: 8px;
}

.group-create-add {
    width: 48px;
    height: 48px;
    background-color: white;
    border: 1px dashed #BDBDBD;
    border-radius: 8px;
}

.group-create-add i {
    color: black;
    font-size: 24px;
}

.cancel-btn {
    background-color: #F2F2F2;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: #828282;
    font-weight: 700;
    border-radius: 8px;
    margin-right: 24px;
}

.accept-btn {
    background-color: #7367F0;
    width: 192px;
    height: 56px;
    font-size: 16px;
    color: white;
    font-weight: 700;
    border-radius: 8px;
}
</style>